import { render } from "./CheckoutBox.vue?vue&type=template&id=d37273ac&scoped=true&ts=true"
import script from "./CheckoutBox.vue?vue&type=script&lang=ts"
export * from "./CheckoutBox.vue?vue&type=script&lang=ts"

import "./CheckoutBox.vue?vue&type=style&index=0&id=d37273ac&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d37273ac"]])

export default __exports__